import { ReactComponent as Arrow } from 'assets/icons/button/arrow.svg';
import PricingTable from 'components/PricingTable';
import { scrollToSection } from 'helpers';
import { useRef, useState } from 'react';

const ProductTable = () => {
    const content = useRef(null);
    const [active, setActive] = useState(false);
    const [height, setHeight] = useState('0px');
    const [shouldAnimate, setShouldAnimate] = useState(false);

    function toggleAccordion() {
        setShouldAnimate(true);
        setActive(!active);
        setHeight(!active ? `${content.current.scrollHeight}px` : '0px');
        if (active) {
            scrollToSection('product-price-table-container', 400);
        }
    }

    function handleTransitionEnd() {
        if (active) {
            setHeight('auto');
            setShouldAnimate(false);
        }
    }

    return (
        <div className="product-price-table">
            <div
                ref={content}
                style={{ height: height, transition: shouldAnimate ? 'height 1s ease-out' : 'none' }}
                className={`product-price-table-container ${active ? 'active' : ''}`}
                onTransitionEnd={handleTransitionEnd}
            >
                <PricingTable />
            </div>
            <button
                className={`button-text product-price-table-button ${active ? 'open' : ''}`}
                onClick={toggleAccordion}
            >
                {active ? <span>Hide</span> : <span>Compare Plans</span>}
                <Arrow className="arrow" />
            </button>
        </div>
    );
};

export default ProductTable;
